import React from 'react';
import Swiper from 'components/react-swiper';

class Slider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current: props.slide || 0
    };

    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
    this.handleSwipe = this.handleSwipe.bind(this);
  }

  get count() {
    if (this.props && this.props.children) {
      return this.props.children.length;
    }

    return 0;
  }

  set count(c) {}

  componentWillMount() {
    require('./Slider.styl');
  }

  prev() {
    if (this.state.current <= 0) return;

    this.setState((state, props) => {
      let nextSlide = state.current - 1;

      if (typeof props.onChange === 'function') {
        props.onChange(nextSlide);
      }

      return {
        current: nextSlide
      };
    });
  }

  next() {
    if (this.state.current >= this.count - 1) return;

    this.setState((state, props) => {
      let nextSlide = state.current + 1;

      if (typeof props.onChange === 'function') {
        props.onChange(nextSlide);
      }

      return {
        current: nextSlide
      };
    });
  }

  handleSwipe({ type }) {
    if (type === 'swipeLeft') {
      this.next();
    }
    if (type === 'swipeRight') {
      this.prev();
    }
  }

  render() {
    const { current } = this.state;

    return (
      <Swiper onSwipe={this.handleSwipe} className="Slider">
        <div className="Slider__side">
          <div
            className={
              'Slider__ctrl ' +
              (this.state.current <= 0 ? 'Slider__ctrl--disabled' : '')
            }
            onClick={this.prev}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M6.2,24l35.6,22.7V1.3L6.2,24z" /></svg>
          </div>
        </div>

        <div className="Slider__box">
          <div
            className="Slider__scroller"
            style={{
              transform: `translateX(${current * -100}%)`
            }}
          >
            {this.props.children}
          </div>
        </div>

        <div className="Slider__side">
          <div
            className={
              'Slider__ctrl ' +
              (current >= this.count - 1 ? 'Slider__ctrl--disabled' : '')
            }
            onClick={this.next}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M6.2,1.3v45.4L41.8,24L6.2,1.3z" /></svg>
          </div>
        </div>
      </Swiper>
    );
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider/index.js